import React, { useState, useEffect } from "react";
import { playNav, playHover } from "../../../utils/sounds";
import "./navbar.css";

const NAV_ITEMS = [
  { id: 'Home', label: 'HOME' },
  { id: 'AboutMe', label: 'ABOUT' },
  { id: 'Skills', label: 'SKILLS' },
  { id: 'Experience', label: 'EXP' },
  { id: 'Projects', label: 'PROJECTS' },
  { id: 'Education', label: 'EDU' },
  { id: 'Resume', label: 'RESUME' },
];

export const Header = () => {
  const [active, setActive] = useState('Home');
  const [time, setTime] = useState('');

  // Live clock
  useEffect(() => {
    const tick = () => {
      setTime(new Date().toLocaleTimeString('en-US', { hour12: false }));
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  // Scroll spy
  useEffect(() => {
    const onScroll = () => {
      const ids = NAV_ITEMS.map(n => n.id).filter(id => id !== 'Home');
      const scrollY = window.scrollY + 140;
      for (let i = ids.length - 1; i >= 0; i--) {
        const el = document.getElementById(ids[i]);
        if (el && el.offsetTop <= scrollY) {
          setActive(ids[i]);
          return;
        }
      }
      setActive('Home');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = (e, id) => {
    e.preventDefault();
    playNav();
    setActive(id);
    if (id === 'Home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const el = document.getElementById(id);
    if (el) {
      window.scrollTo({ top: el.offsetTop - 55, behavior: 'smooth' });
    }
  };

  return (
    <header className="crt-header" role="navigation" aria-label="Main navigation">
      <nav className="crt-nav">
        <div className="nav-logo" aria-label="Amrinder Bhogal">
          <span className="logo-bracket">[</span>
          <span className="logo-text">AB</span>
          <span className="logo-bracket">]</span>
        </div>

        <div className="nav-links">
          {NAV_ITEMS.map(item => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={e => handleClick(e, item.id)}
              onMouseEnter={playHover}
              className={`nav-link ${active === item.id ? 'active' : ''}`}
              aria-current={active === item.id ? 'true' : undefined}
            >
              {item.label}
            </a>
          ))}
        </div>

        <div className="nav-status">
          <span className="status-dot-live"></span>
          <span className="status-time">{time}</span>
        </div>
      </nav>
    </header>
  );
};

export default Header;
